import React, { ReactElement } from "react";
import MainBanner from "@components/payrollsystem/mainBanner";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import PayrollSystemWrapper from "@components/layouts/payrollSystemWrapper";
const OffersList = dynamic(() => import("@components/shared/offersList"));

const WhyUs = dynamic(() => import("@components/payrollsystem/whyUs"));

export default function PayrollSystemsHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <PayrollSystemWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </PayrollSystemWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
